import axios from 'axios';
import {
  ACTION_TYPES,
  ACTIVITY_FILTERS,
  NOTIFICATION_TYPES,
} from './constants';

const baseUrl = process.env.REACT_APP_API_URL;
const config = {
  headers: { Authorization: '' },
};

const activityFilterToApiParams = (filter, unreadOnly = false) => {
  const base = unreadOnly ? { unread: true } : {};
  switch (filter) {
    case ACTIVITY_FILTERS[1]:
      return { ...base, types: NOTIFICATION_TYPES.TASK_NOTIFICATION };
    case ACTIVITY_FILTERS[2]:
      return { ...base, mentioned: true };
    case ACTIVITY_FILTERS[3]:
      return { ...base, types: NOTIFICATION_TYPES.CHAT_REPLY_NOTIFICATION };
    default:
      return base;
  }
};

export const getWorkspaceNotifications = ({
  filter = ACTIVITY_FILTERS[0],
  loadMore = false,
  isSync = false,
  loadUnread = false,
  callback,
} = {}) => {
  const workspaceId =
    sessionStorage.getItem('workspaceId') ||
    localStorage.getItem('workspaceId');

  const [requestType, successType, failureType] = loadMore
    ? [
        ACTION_TYPES.GET_MORE_NOTIFICATIONS_REQUEST,
        ACTION_TYPES.GET_MORE_NOTIFICATIONS_SUCCESS,
        ACTION_TYPES.GET_MORE_NOTIFICATIONS_FAILURE,
      ]
    : isSync
      ? [
          ACTION_TYPES.SYNC_NOTIFICATIONS_REQUEST,
          ACTION_TYPES.SYNC_NOTIFICATIONS_SUCCESS,
          ACTION_TYPES.SYNC_NOTIFICATIONS_FAILURE,
        ]
      : [
          ACTION_TYPES.GET_NOTIFICATIONS_REQUEST,
          ACTION_TYPES.GET_NOTIFICATIONS_SUCCESS,
          ACTION_TYPES.GET_NOTIFICATIONS_FAILURE,
        ];

  return async (dispatch, getState) => {
    let res;
    try {
      const state = getState();
      const activeFilter = state?.notificationReducer?.activeFilter;
      const lastSeen = state?.notificationReducer?.lastSeenTimestamp;
      const page = loadMore
        ? state?.notificationReducer?.pageToLoad
        : undefined;
      const activityFilterParams = activityFilterToApiParams(
        isSync ? activeFilter : filter,
        loadUnread,
      );

      if (isSync && !lastSeen) {
        return null;
      }

      const query = Object.fromEntries(
        Object.entries({
          page,
          ...activityFilterParams,
          ...(isSync ? { since: lastSeen } : {}),
        }).filter(([, value]) => value !== undefined),
      );
      config.params = query;
      dispatch({
        type: requestType,
        payload: {
          filter,
          unreadOnly: loadUnread,
        },
      });
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      const baseUrlV2 = baseUrl?.replace('/api/v1', '/api/v2');
      res = await axios.get(
        `${baseUrlV2}/notifications/workspace/${workspaceId}`,
        config,
      );
      dispatch({
        type: successType,
        payload: { ...(res?.data || {}), filter, unreadOnly: loadUnread },
      });
      if (typeof callback == 'function') {
        callback(res?.data?.data);
      }
      return res.data.notifications;
    } catch (error) {
      console.log('---- error', error);
      dispatch({
        type: failureType,
        payload: res.data,
      });
    }
  };
};

// FIXME: not used anymore
// export const deleteNotifications = (userId, callback) => {
//   const workspaceId =
//     sessionStorage.getItem('workspaceId') ||
//     localStorage.getItem('workspaceId');
//   return async (dispatch) => {
//     let res;
//     try {
//       dispatch({
//         type: ACTION_TYPES.DELETE_NOTIFICATION_REQUEST,
//       });
//       config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
//       res = await axios.delete(
//         `${baseUrl}/notifications/${workspaceId}`,
//         config,
//       );
//       dispatch({
//         type: ACTION_TYPES.DELETE_NOTIFICATION_SUCCESS,
//         payload: res.data.notifications,
//       });
//       callback();
//     } catch (error) {
//       dispatch({
//         type: ACTION_TYPES.DELETE_NOTIFICATION_FAILURE,
//         payload: res.data,
//       });
//     }
//   };
// };

//update View Notification
export const markNotificationsRead = (body) => {
  return async (dispatch) => {
    const workspaceId =
      sessionStorage.getItem('workspaceId') ||
      localStorage.getItem('workspaceId');

    let res;
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      await axios.put(`${baseUrl}/notifications/read/all`, body, config);

      if (!config?.params) {
        dispatch({
          type: ACTION_TYPES.SET_UNREAD_COUNT,
          payload: 0,
        });
      } else {
        const baseUrlV2 = baseUrl?.replace('/api/v1', '/api/v2');
        res = await axios.get(
          `${baseUrlV2}/notifications/workspace/${workspaceId}`,
          { headers: config.headers },
        );
        dispatch({
          type: ACTION_TYPES.SET_UNREAD_COUNT,
          payload: res?.data?.unreadNotifications,
        });
      }
    } catch (error) {
      // dispatch({
      //   type: ACTION_TYPES.UPDATE_NOTIFICATION_FAILURE,
      //   payload: res?.data,
      // });
    }
  };
};

//update View Notification
export const updateViewNotification = (body) => {
  return async (dispatch) => {
    let res;
    try {
      dispatch({
        type: ACTION_TYPES.UPDATE_NOTIFICATION_REQUEST,
      });
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      res = await axios.put(`${baseUrl}/notifications/update`, body, config);
      dispatch({
        type: ACTION_TYPES.UPDATE_NOTIFICATION_SUCCESS,
        payload: res?.data?.data,
      });
    } catch (error) {
      dispatch({
        type: ACTION_TYPES.UPDATE_NOTIFICATION_FAILURE,
        payload: res?.data,
      });
    }
  };
};

// FIXME: not used anymore
// export const clearNotification = (body) => {
//   return async (dispatch) => {
//     let res;
//     try {
//       dispatch({
//         type: ACTION_TYPES.UPDATE_NOTIFICATION_REQUEST,
//       });
//       config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
//       res = await axios.put(`${baseUrl}/notifications/clear`, body, config);
//       if (!body?.isViewed) {
//         dispatch({
//           type: ACTION_TYPES.UPDATE_TOTAL_UNREAD_COUNT,
//         });
//       }
//     } catch (error) {
//       dispatch({
//         type: ACTION_TYPES.UPDATE_NOTIFICATION_FAILURE,
//         payload: res?.data,
//       });
//     }
//   };
// };

export const updateQueryState = (state) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPES.UPDATE_QUERY_STATE,
      payload: state,
    });
  };
};

export const updateNotificationState = (state) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPES.UPDATE_ONE_NOTIFICATION,
      payload: state,
    });
  };
};

export const newSocketNotification = (payload) => {
  return {
    type: ACTION_TYPES.NEW_SOCKET_NOTIFICATION,
    payload,
  };
};

export const newFCMNotification = (payload) => ({
  type: ACTION_TYPES.NEW_FCM_NOTIFICATION,
  payload,
});

export const syncNotificationsAfterReconnect = () => (dispatch) => {
  dispatch(getWorkspaceNotifications({ isSync: true }));
};
